export async function copyToClipboard(text: string): Promise<boolean> {
  if (!navigator.clipboard) {
    // execCommand says whether the copy happened; a refusal is false, not a throw (TOADO-974 review).
    const el = document.createElement('textarea');
    try {
      el.value = text;
      el.style.position = 'fixed';
      el.style.opacity = '0';
      document.body.appendChild(el);
      el.select();
      return document.execCommand('copy');
    } catch {
      return false;
    } finally {
      el.remove();
    }
  }
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
